// extracted by mini-css-extract-plugin
export default {"Calendar":"Icons_Calendar__NfHWA"};